import { generateCodeChallengeFromVerifier } from './codeChallenge'

export const authorizeSCA = async (
  orgId: string,
  vesselId: string,
  connectedAccountId: string,
  accessToken: string,
  codeVerifier: string,
) => {
  const codeChallenge = await generateCodeChallengeFromVerifier(codeVerifier)
  const payload = {
    codeChallenge,
  }

  const res = await fetch(
    `/api/pay/org/${orgId}/vessel/${vesselId}/connected-account/${connectedAccountId}/sca/authorize`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    },
  )

  if (!res.ok) {
    throw new Error(`Failed to authorize SCA: ${res.status}`)
  }

  return await res.json()
}
